import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Live reportAccess/{reportId} docs keyed by report id (see utils/reportCatalog.js).
 * A report with no doc uses its defaultAccess.
 */
export default function useReportAccess(enabled = true) {
  const [accessDocs, setAccessDocs] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    return onSnapshot(
      collection(db, 'reportAccess'),
      (snap) => {
        const next = {};
        snap.forEach((d) => { next[d.id] = d.data(); });
        setAccessDocs(next);
        setLoaded(true);
      },
      (error) => {
        console.error('Error loading report access:', error);
        setLoaded(true);
      }
    );
  }, [enabled]);

  return { accessDocs, loaded };
}
